<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper">
    <layouts></layouts>
    <sidebar></sidebar>
    <div class="page-wrapper">
      <div class="content">
        <pageaddheader :title="title" :title1="title1" :items="items"/>

        <f-table
            :filters="['name', 'account_number', 'mobile_number', 'email']"
            :data="users"
            :columns="columns"
            @pageChange="getUsers($event)"
            @filter="getUsers({ query: $event.query })"
            :paginationConfig="paginationConfig"
        >
          <template #bodyCell="{ column, record }">
            <template v-if="toggleConfig[column.key]">
  <span v-if="!hasAccess(getRequiredPermission(column.key))">
    {{ displayValue(column.key, record) }}
  </span>

              <div
                  v-else
                  class="status-toggle d-flex justify-content-between align-items-center"
              >
                <input
                    :name="record.id + '-' + column.key"
                    type="checkbox"
                    :id="record.id + '-' + column.key"
                    :checked="getChecked(column.key, record)"
                    @change="onToggle(column.key, record.id, $event.target.checked)"
                    class="check"
                />
                <label :for="record.id + '-' + column.key" class="checktoggle">
                  checkbox
                </label>
              </div>
            </template>

            <template v-else-if="column.key === 'action'">
              <router-link class="me-3" :to="'edit-user/' + record.id">
                <img src="../../../assets/img/icons/edit.svg" alt="img"/>
              </router-link>
              <a
                  class="me-3 confirm-text"
                  href="javascript:void(0);"
                  @click="showAlert"
              >
                <img src="../../../assets/img/icons/delete.svg" alt="img"/>
              </a>
            </template>
          </template
          >
        </f-table>
      </div>
    </div>
  </div>
</template>
<script>
import {ref} from "vue";

const currentDate = ref(new Date());
const columns = [
  {
    sorter: true,
  },
  {
    title: "Customer Name",
    dataIndex: "name",
    sorter: {
      compare: (a, b) => {
        a = a.name;
        b = b.name;
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Account Number",
    dataIndex: "account_number",
    sorter: {
      compare: (a, b) => {
        a = a.account_number;
        b = b.account_number;
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Mobile Number",
    dataIndex: "mobile_number",
    sorter: (a, b) => a.mobile_number.localeCompare(b.mobile_number),
  },
  {
    title: "email",
    dataIndex: "email",
    sorter: {
      compare: (a, b) => {
        a = a.email.toLowerCase();
        b = b.email.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Account Type",
    dataIndex: "account_type",
    sorter: {
      compare: (a, b) => {
        a = a.account_type.toLowerCase();
        b = b.account_type.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Credit Limit",
    dataIndex: "credit_limit",
    sorter: {
      compare: (a, b) => {
        a = a.credit_limit.toLowerCase();
        b = b.credit_limit.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Created On",
    dataIndex: "created_at",
    sorter: {
      compare: (a, b) => {
        a = a.created_at?.toLowerCase();
        b = b.created_at?.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Status",
    key: "status",
    sorter: {
      compare: (a, b) => {
        a = a.status.toLowerCase();
        b = b.status.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "No Debit",
    key: "no_debit",
    sorter: {
      compare: (a, b) => {
        a = a.no_debit.toLowerCase();
        b = b.no_debit.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Due Free",
    key: "due_free",
    sorter: {
      compare: (a, b) => {
        a = a.due_free.toLowerCase();
        b = b.due_free.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Action",
    key: "action",
    sorter: true,
  },
];

import {mapActions, mapGetters} from "vuex";

export default {
  data() {
    return {
      filter: false,
      title: "User List",
      title1: "Manage your User",
      items: [
        {
          text: "Add User",
          addname: "/newuser",
        },
      ],
      account_type: null,
      users: [],
      columns,
      startdate: currentDate,
      Disable: ["Disable", "Enable"],
      paginationConfig: {current_page: 1, per_page: 10},
      searchQuery: null,


      toggleConfig: {
        status: {
          permission: "update-user",
          display: (record) => record.status === "Active" ? "Active" : "InActive",
          checked: (record) => record.status === "Active",
          action: (id, checked) => this.updateUserStatus(id, checked),
        },
        no_debit: {
          permission: "no-debit",
          display: (record) => record.no_debit ? "Active" : "InActive",
          checked: (record) => !!record.no_debit,
          action: (id, checked) => this.updateUserNoDebitStatus(id, checked),
        },
        due_free: {
          permission: "due-free",
          display: (record) => record.due_free ? "Active" : "InActive",
          checked: (record) => !!record.due_free,
          action: (id, checked) => this.updateDueFreeStatus(id, checked),
        },
      },
    };
  },
  computed: {
    ...mapGetters({
      hasAccess: "hasAccess",
    }),
  },
  methods: {
    ...mapGetters(["formatAmount"]),
    ...mapActions({
      _getUsers: "users/get",
      _updateUser: "users/update",
    }),
    showAlert() {
      // Use sweetalert2
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        showCancelButton: true,
        confirmButtonColor: "#FF9F43",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire("Deleted!", "Your file has been deleted.");
        }
      });
    },
    getUsers({page = null, per_page = null, query = null} = {}) {
      this.account_type = this.$route.params.account_type;
      const params = {
        page: page ?? this.paginationConfig.current_page,
        per_page: per_page ?? this.paginationConfig.per_page,
        query: query ?? this.searchQuery,
        account_type: this.$route.params.account_type,
      };
      this.searchQuery = query;
      this._getUsers(params).then((apiResponse) => {
        const response = apiResponse.data;
        this.users = response.data.map((user) => {
          return {
            id: user.id,
            name: user.name,
            account_number: user.account_number,
            mobile_number: user.mobile_number,
            email: user.email,
            has_custom_credit_limit: user.has_custom_credit_limit,
            credit_limit: Number(user.credit_limit).toLocaleString("en-US"),
            account_type: user.account_type.name,
            created_at: user.date,
            status: user.is_active === 1 ? "Active" : "InActive",
            no_debit: user.no_debit,
            due_free: user.due_free,
          };
        });

        this.paginationConfig = response.pagination;
      });
    },
    updateUserStatus(userId, status) {
      this._updateUser({user_id: userId, payload: {status: status}}).then(
          (res) => {
            this.getUsers();
          }
      );
    },
    async updateUserNoDebitStatus(userId, status) {
      const payload = {no_debit: status}

      try {
        await this._updateUser({
          user_id: userId,
          payload
        });

        // Option 1: Refresh full list
        this.getUsers();
      } catch (error) {
        console.error(error);
      }
    },
    async updateDueFreeStatus(userId, status) {
      const payload = {due_free: status}

      try {
        await this._updateUser({
          user_id: userId,
          payload
        });

        // Option 1: Refresh full list
        this.getUsers();
      } catch (error) {
        console.error(error);
      }
    },

    getRequiredPermission(key) {
      return this.toggleConfig[key]?.permission ?? null;
    },
    displayValue(key, record) {
      return this.toggleConfig[key]?.display(record) ?? "";
    },
    getChecked(key, record) {
      return this.toggleConfig[key]?.checked(record) ?? false;
    },
    onToggle(key, id, checked) {
      this.toggleConfig[key]?.action(id, checked);
    },
  },
  watch: {
    $route: {
      handler(_old, _new) {
        this.getUsers();
      }
      ,
      immediate: true,
    }
    ,
  }
  ,
  mounted() {
    this.getUsers();
  }
  ,
  name: "userlists",
}
;
</script>
